import { useEffect, useState, Fragment } from "react"
import { Row, Table } from "antd"
import Search from "../../components/Inputs/Search/Search"
import type { MenuProps } from "antd"
import closeIcon from "../../images/_close.svg"
import documentIcon from "../../images/document.png"
import Selector from "../../components/Selector/Selector"
import eyeIcon from "../../images/eye.png"
import editIcon from "../../images/_edit.svg"
import CustomTable from "../../components/CustomTable/CustomTable"
import { Typography } from "antd"
import "./TransactionalCampaigns.css"
import PrimaryButton from "../../components/Buttons/PrimaryButton/PrimaryButton"
import { useSelector } from "react-redux"
import InnerNav from "../../components/InnerNav/InnerNav"
import centralApi from "../../services/centralApi"
import useMessage from "../../hooks/useMessage"
import { t } from "i18next"
import { API_ENDPOINTS, ROUTES } from "utils/constants"
import { downloadCsv } from "../../helperFunctions/common";
import downloadIcon from "../../images/downloadNew.svg";
import { AudienceEnum, CampaignStatusEnum, DataTypeEnum } from "utils/enums"
import { PAGE_OPTIONS } from "utils/constants/selectorOptions"
import { DateRangeSelector } from "components/DateTimeSelectors/DateRangeSelector/DateRangeSelector"
import { DateRangeData } from "@customTypes/dateRange"
import { Link,useNavigate } from "react-router-dom"
import { formatDate } from "helperFunctions/date"
import CustomBreadCrumb from "components/CustomBreadCrumb/CustomBreadCrumb"
import { CopyTwoTone } from "assets/icons"
import { copyText } from "helperFunctions/string"


type dataType = {
  key: number
  nm: string
  Audience_Segment: string
  Reachable_Audience: string
  Sent: string
  Clicked: string
  CTR: string
  Start_Date: string
  End_Date: string
  Action: string
}

const { Text } = Typography

const TransactionalCampaigns: React.FC = () => {
  const [campaignTabFilter, setCampaignTabFilter] = useState("ACTIVE")
  const [usersData, setUsersData] = useState<any>([])
  const [usersDataCopy, setUsersDataCopy] = useState<any>([])
  const [pageData, setPageData] = useState(PAGE_OPTIONS.PAGINATION)
  const [loading, setLoading] = useState(false)
  const { showError, showSuccess } = useMessage()
  const navigate = useNavigate()


  const loginUser = useSelector((state: any) => state.loginUser)
  const activeApp = useSelector((state: any) => state.activeApp)
  const appId = activeApp.appId
  const api_key = loginUser.data.api_key
  const [dateRange, setDateRange] = useState<DateRangeData | null>(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([])
  const [columnStatus, setColumnStatus] = useState<any>({
    clickedTo: false,
    conversion: false,
    ctr: false,
    impressionRate: false,
    receivedTo: false
  });
  const handleTextCopy = async (text: string) => {
    const res = await copyText(text)
    showSuccess(res.message)
  }
  const columns: any = [
    {
      title: t("typeLabel"),
      dataIndex: "t",
      className: "fix",
      width: 10,
      sorter: (a: { t: string }, b: { t: string }) => 
        a.t.localeCompare(b.t),
    },
    {
      title: (
        <div className="d-flex justify-content-between align-items-baseline">
          {t("nameLabel")}
    
        </div>
      ),
      key:"nm",
      width: 220,
      sorter: (a: { nm: string }, b: { nm: string }) => 
        
        a.nm.localeCompare(b.nm),
      render: (details: any) => (
        
        <div className="d-flex flex-column transactional-campaign-name-cell">
          <Link to={`${ROUTES.DASHBOARD_CAMPAIGN}/${details.cid}`}>{details.nm}</Link>

          <span className="text-disabled d-flex align-items-center justify-content-between">
            {t("IdLabel")}: {details._id}
            <CopyTwoTone onClick={() => handleTextCopy(details._id)} />
          </span>
        </div>
      ),
    },
   
    {
      title: t("audienceSegmentLabel"),
      dataIndex: "segmentName",
      width: 150,
      sorter: (a: { segmentName: string }, b: { segmentName: string }) => 
        a.segmentName.localeCompare(b.segmentName),

    },
    {
      title: t("reachableAudienceLabel"),
      dataIndex: "reach",
      width: 120,
      sorter: (a: { reach: number }, b: { reach: number }) => a.reach - b.reach

    },
    {
      title: t("sentLabel"),
      dataIndex: "pushedTo",
      width: 10,
      sorter: (a: { pushedTo: number }, b: { pushedTo: number }) => a.pushedTo - b.pushedTo

    },
    ...(columnStatus?.receivedTo 
      ? [
  {
    title: t("receivedLabel"),
    dataIndex: "receivedTo",
    width: 10,
    sorter: (a: { receivedTo: number }, b: { receivedTo: number }) => a.receivedTo - b.receivedTo

  },
]
: []),
...(columnStatus?.impressionRate ?[

  {
    title: t("impressionRateLabel"),
    dataIndex: "impressionRate",
    className: "text-center",
    width: 10,
    sorter: (a, b) => {
      const valA = typeof a.impressionRate === DataTypeEnum.STRING ? parseFloat(a.impressionRate) : a.impressionRate;
      const valB = typeof b.impressionRate === DataTypeEnum.STRING ? parseFloat(b.impressionRate) : b.impressionRate;
      return valA - valB;
    }
    

  },]:[]),
    ...(columnStatus?.clickedTo ?[

      {
        title: t("clickedLabel"),
        dataIndex: "clickedTo",
        width: 10,
        sorter: (a: { clickedTo: number }, b: { clickedTo: number }) => a.clickedTo - b.clickedTo
  
      },]:[]),
     
  
  ...(columnStatus?.ctr ?[

    
    {
      title: t("CTRLabel"),
      dataIndex: "ctr",
      width: 10,
      sorter: (a, b) => {
        const valA = typeof a.ctr === DataTypeEnum.STRING ? parseFloat(a.ctr) : a.ctr;
        const valB = typeof b.ctr === DataTypeEnum.STRING ? parseFloat(b.ctr) : b.ctr;
        return valA - valB;
      }
    },]:[]),
    ...(columnStatus?.conversion ?[

    {
      title: t("conversionLabel"),
      dataIndex: "conversion",
      width: 10,
      sorter: (a: { conversion: number }, b: { conversion: number }) => a.conversion - b.conversion

    },]:[]),
    {
      title: t("startDateLabel"),
      dataIndex: "sd",
      width: 10,
      sorter: (a: { sd: number }, b: { sd: number }) => a.sd - b.sd,

      render: (sd: number) => {
        return <div>{formatDate(sd, 'DD-MM-YYYY hh:mm:ss A')}</div>;

      },
    

    },
    {
      title: t("endDateLabel"),
      dataIndex: "ed",
      width: 10,
      sorter: (a: { ed: number }, b: { ed: number }) => a.ed - b.ed,

      render: (ed: number) => {
        return <div>{formatDate(ed, 'DD-MM-YYYY hh:mm:ss A')}</div>;

      },
    
    },
    {
      title: t("actionLabel"),
      dataIndex: "",
      width: 130,
      className: "item-align",
      render: (campaign: any) => {
        console.log("campaign==>",campaign)
        return (
          <Fragment>

              <PrimaryButton
              title={t("editLabel")}
              disabled={campaign?.segmentName === AudienceEnum.CUSTOM_AUDIENCE}
                className="action-btn mx-1"
                onClick={() =>
                  navigate(ROUTES.DASHBOARD_CAMPAIGN_CREATE, {
                    state: { cid: campaign._id, type: campaign.t },
                  })
                }
                
              >
                <img src={editIcon} alt={"edit_icon"} className="icon-width"></img>
              </PrimaryButton>
              <PrimaryButton
              title="Delete"
                className="action-btn mx-1"
                onClick={() => {
                  setCampStatus(campaign?.cid, campaign?.active, "DRAFT")
                }}
              >
                <img
                  src={closeIcon}
                  alt={"close_icon"}
                  className="icon-width"
                ></img>
              </PrimaryButton>
              <PrimaryButton
              title="Copy"
                className="action-btn mx-1"
                onClick={() => {
                  copyCamp(campaign?.cid, campaign?.active)
                }}
              >
                <img
                  src={documentIcon}
                  alt={"document_icon"}
                  className="icon-width"
                ></img>
              </PrimaryButton>
               
              <Link to={`${ROUTES.DASHBOARD_CAMPAIGN}/${campaign.cid}`}>
                <PrimaryButton title={t("viewDetailsLabel")}  disabled={campaign?.segmentName === AudienceEnum.CUSTOM_AUDIENCE}  className="action-btn mx-1">
                  <img
                    src={eyeIcon}
                    alt={"eye_icon"}
                    className="icon-width"
                  ></img>
                </PrimaryButton>
            </Link>
          </Fragment>
        )
      },
    },
  ]

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchText = e.target.value.toLowerCase()
    const filteredData = usersData.filter((user: any) => {
      return (
        user?.nm?.toLowerCase().includes(searchText) ||          // search by name
        user?.cid?.toLowerCase().includes(searchText)         // search by campaign id
      );
    });
    setUsersDataCopy(filteredData)
  }

  useEffect(() => {
    setUsersDataCopy(usersData)
  }, [usersData])
  const startDateSeconds = dateRange?.startDate_C !== undefined ? dateRange.startDate_C * 1000 : null;
  const endDateSeconds = dateRange?.endDate_C !== undefined ? dateRange.endDate_C * 1000 : null;

  /**
   * getTransactionalCampaignData will get us campaigns by status
   * @param status will describe the status of campaign i.e active,draft or past 
   */
  
  async function getTransactionalCampaignData(status: string) {
    const payload = {
      status: status,
      app_id: appId,
      api_key: api_key,
      cmpType: "t",
      sd:startDateSeconds,
        ed:endDateSeconds,
       
    }
    
    const url: string = API_ENDPOINTS.GET_CAMPAIGNS_BY_STATUS
   

    try {
      setLoading(true)
      const data = await centralApi("GET", url, null, payload)
      setUsersData(data.retVal)
      if(data?.columnStatus){
        setColumnStatus(data?.columnStatus)
      }
      setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }

  const onTabClick: MenuProps["onClick"] = (e) => {
    setCampaignTabFilter(e.key)
    setPageData(PAGE_OPTIONS.PAGINATION)
    setSelectedRowKeys([]);

  }
 
  async function setCampStatus(cid: string, status: string, st: string) {
    try {
      const payload = {
        args: JSON.stringify({
          a: status,
          ud: Date.now(),
          st: st,
        }),
        cid,
        app_id: appId,
        api_key: api_key,
      }
      setLoading(true)
       await centralApi("GET", API_ENDPOINTS.SET_ACTIVE_CAMPAIGN_URL, null, payload)

     showSuccess(t("copiedIntoDraftMsg"))
      getTransactionalCampaignData(campaignTabFilter)
    } catch (error) {
      showError(t("somethingWrongLabel"));

    }
  }

  async function copyCamp(cid: string, status: string) {
    try {
      const payload = {
        args: JSON.stringify({
          d: status,
          ud: Date.now(),
        }),
        cid,
        app_id: appId,
        api_key: api_key,
      }
      await centralApi("GET", API_ENDPOINTS.COPY_CAMPAIGN_URL, null, payload)

      showSuccess(t("copiedIntoDraftMsg"))
    } catch (error) {
      showError(t("somethingWrongLabel"));

    }
  }
  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys)
  }
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    selections: [
      Table.SELECTION_ALL],

  };

const onPageChange = (value: any) => {
  setPageData(value)
}
  useEffect(() => {
    if (api_key) {
      getTransactionalCampaignData(campaignTabFilter)
    }
  }, [dateRange, loginUser, campaignTabFilter])

  const filename = t('TransactionalCampCsvFileName'); 
  /**
   * downloadTranCampaign will download the csv file for transactional campaigns 
   */
  const downloadTranCampaign = async () => {
    const payload = {
      api_key: api_key,
      app_id: appId,
      cy : "t",
      status : campaignTabFilter,
      filename : filename,
      sd: startDateSeconds, 
      ed: endDateSeconds, 
     

    };
    const url: string = API_ENDPOINTS.DOWNLOAD_TRANSACTIONAL_CAMPDATA;

    try {
      const response = await centralApi("GET", url, null, payload, true);
      downloadCsv(response, filename);
      showSuccess(t("downloadedSuccessfullyLabel"));
    } catch (error: any) {
      showError(error.message);
    }
  };

  const handleDateRange = (dateRangeData: any) => {
    setDateRange(dateRangeData);
  };
  return ( 
    <Fragment>
    <div className="transactional-campaigns-main-wrapper">
      <Row className="transactional-campaigns-header py-2">
        <CustomBreadCrumb
            items={[
              {
                title: (
                  <Link to={ROUTES.DASHBOARD_TRANSACTIONALCAMPAIGN}>
                    {t("transactionalCampaignLabel")}
                  </Link>
                ),
              },
            ]}
          />
   
      </Row>
      <div className="d-flex  justify-content-between py-2 w-100">

      <div className="w-50">
        <InnerNav
          theme="light"
          onTabClick={onTabClick}
          selected={campaignTabFilter}
          menu={[
            {
              label: t("activeLabel"),
              key: CampaignStatusEnum?.ACTIVE,
            },
            {
              label:t("draftLabel"),
              key: CampaignStatusEnum?.DRAFT,
            },
            {
              label: t("pastLabel"),
              key: CampaignStatusEnum?.PAST,
            },
          ]}
        />
              </div>

              <div className=" d-flex align-items-center justify-content-end gap-1 w-50">
            <strong>{t("periodLabel")} </strong>
            <div>
          <DateRangeSelector
              onDateChange={handleDateRange}
              initialValue={{}}
              disableRange={{ range: 1, rangeType: "year" }}
              disableType="years"
              disableFuture={false}

            />  
            </div>  </div>
      </div>

      <div className="px-sm-3 px-1 transactional-campaign-table-container">
        <div className="d-flex flex-row w-100 py-4 ">
          <div>
            <Search
                placeholder={`${t("searchLabel")}`}
                      onChange={handleSearch}
              size="middle"
             className="transactional-campaign-search"
            />
          </div>
          <Text className="my-auto ms-2 me-2">Show </Text>
          <Selector
                  onChange={(value) => {
                    setPageData({ ...pageData, pageSize: value })
                  }}

                  defaultValue={PAGE_OPTIONS.DEFAULT_VALUE}
                  size="middle"
                  options={PAGE_OPTIONS.DATA}
                />
          <Text className="my-auto ms-2">Entries </Text>
          <PrimaryButton title={t("downloadCsvLabel")}className="ms-auto" onClick={downloadTranCampaign}>
            <img src={downloadIcon}  alt="download icon"></img>
          </PrimaryButton>
        </div>

        <div>
          <CustomTable
            columns={columns}
            onChange={onPageChange}
            rowSelection={rowSelection}

            dataSource={
                usersDataCopy?.map((user: any) => ({
                    ...user,
                    key: user._id

                  }))

            }
            loading={loading}
            pagination={{
              current: pageData.current,
              pageSize: pageData.pageSize,
              simple: pageData.simple,
              total: usersDataCopy.length,
            }}
            scroll={{ x: 2500 }}
          />
        </div>
      </div>
    </div>
    </Fragment>
  )
}

export default TransactionalCampaigns

TransactionalCampaigns.defaultProps = {
  tableSize: "small",
  pageSize: 10,
}
